import { normalizeRichTextWhitespace } from '@utils/helpers';

import { MobileCompanyPoliciesContent } from './CompanyPolicies.styled';

interface CompanyPoliciesMobileProps {
    content: string;
}

export const CompanyPoliciesMobile = ({
    content,
}: CompanyPoliciesMobileProps) => {
    return (
        <MobileCompanyPoliciesContent
            className={'ql-editor'}
            dangerouslySetInnerHTML={{
                __html: normalizeRichTextWhitespace(content),
            }}
        />
    );
};
